<template>
  <v-row no-gutters class="ma-0 pb-0 fill-height">
    <v-col cols="12" md="7" v-if="$root.isDesktop">
      <v-img height="100%" :src="background"></v-img>
    </v-col>
    <v-col cols="12" md="5" class="my-4 d-flex align-center justify-center">
      <v-container v-if="userData.listPointOfSale.length === 0 && !recovery">
        <v-form ref="form">
          <v-row class="ml-md-5">
            <v-col cols="12" class="text-center">
              <span class="title-font-secondary">{{ t("title") }}</span>
            </v-col>
            <v-col cols="12">
              <sc-text-field
                rule-required
                rule-email
                :value="model.email"
                :label="t('email')"
                @input="inputEmail"
              ></sc-text-field>
            </v-col>
            <v-col cols="12">
              <sc-text-field
                required
                type="password"
                rule-required
                v-model="model.password"
                :label="t('password')"
                @keyup.enter="signIn"
              ></sc-text-field>
            </v-col>
            <v-col cols="12" class="my-0 py-0">
              <v-alert
                v-if="failed"
                transition="scale-transition"
                class="rounded-xl"
                dense
                text
                type="error"
                >{{ t("messages.error-login") }}</v-alert
              >
            </v-col>
            <v-col cols="12">
              <sc-btn :loading="loading" @click="signIn" block>{{
                t("login")
              }}</sc-btn>
            </v-col>
            <v-col cols="12" class="d-flex flex-column align-center">
              <sc-btn to="/signup" block outlined>{{
                t("btnRegistration")
              }}</sc-btn>
              <div class="mt-3 text-decoration-underline primary--text">
                <sc-btn @click="recovery = true" text>{{
                  t("btnForgotPassword")
                }}</sc-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="userData.listPointOfSale.length > 0">
        <v-form ref="form" @submit.prevent="">
          <v-row class="ml-md-5">
            <v-col cols="12" class="text-center">
              <span class="title-font-secondary">{{ t("selectPv") }}</span>
            </v-col>
            <v-col cols="12">
              <sc-text-field
                type="select"
                :items="userData.listPointOfSale"
                rule-required
                item-text="codename"
                item-value="id"
                v-model="userData.pointOfSaleSelected"
                :label="t('pointSale')"
              ></sc-text-field>
            </v-col>

            <v-col cols="12" class="d-flex flex-column align-center">
              <sc-btn :loading="loading" @click="confirmPointOfSale" block>{{
                t("login")
              }}</sc-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="recovery && !recoverySended">
        <v-form ref="form" @submit.prevent="">
          <v-row class="ml-md-5">
            <v-col cols="12" class="text-center">
              <span class="title-font-secondary">{{
                t("recoveryPassord")
              }}</span>
            </v-col>
            <v-col cols="12">
              <sc-text-field
                rule-required
                rule-email
                v-model="model.email"
                :label="t('email')"
              ></sc-text-field>
            </v-col>

            <v-col cols="12">
              <sc-btn :loading="loading" @click="resetPassword" block>{{
                t("recoveryPassord")
              }}</sc-btn>
            </v-col>
            <v-col cols="12">
              <sc-btn @click="recovery = false" outlined block>{{
                t("cancel")
              }}</sc-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container v-if="recoverySended">
        <v-row class="ml-md-5">
          <v-col cols="12" class="text-center">
            <span class="title-font-secondary">{{ t("recoveryPassord") }}</span>
          </v-col>
          <v-card-text class="text-center">
            {{ t("messages.recovery") }}
          </v-card-text>

          <v-col cols="12">
            <sc-btn :loading="loading" @click="backToLogin" block>{{
              t("login")
            }}</sc-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import {
  SAVE_TOKEN,
  SAVE_USER,
  SET_LIST_POINT_OF_SALES,
} from "@/constants/mutations-type";
import { mapMutations } from "vuex";
export default {
  data: () => ({
    background: require("@/assets/images/background-login.png"),
    loading: false,
    recoverySended: false,
    recovery: false,
    failed: false,

    model: {
      email: null,
      password: null,
    },
    userData: {
      pointOfSaleSelected: null,
      access_token: null,
      listPointOfSale: [],
    },
  }),
  methods: {
    ...mapMutations("auth", [SAVE_TOKEN, SAVE_USER]),
    ...mapMutations("designer", [SET_LIST_POINT_OF_SALES]),
    inputEmail(e) {
      this.model.email = e.toLowerCase()
    },
    signIn() {
      if (!this.$refs.form.validate()) return null;
      this.loading = true;
      this.API.auth
        .signIn(this.model)
        .then(({ token, list }) => {
          this.userData.access_token = token.access_token;
          //Si no tiene ningun punto de venta, entra directamente
          if (!list) return this.confirmLogin();
          if(list.length === 0) return this.confirmLogin();
          //Si tiene 1 punto de venta, entra directamente
          if (list.length === 1) {
            this.userData.pointOfSaleSelected = list[0].id;
            return this.confirmLogin();
          }
          //Si tiene mas de un punto de venta, debera seleccionar uno
          this.userData.listPointOfSale = list;
        })
        .catch((e) => (console.log(e), (this.failed = true)))
        .finally(() => {
          this.loading = false;
          setTimeout(() => (this.failed = false), 2500);
        });
    },
    confirmPointOfSale() {
      if (!this.$refs.form.validate()) return null;
      this.confirmLogin();
    },
    backToLogin() {
      this.recovery = false;
      this.recoverySended = false;
    },
    resetPassword() {
      if (!this.$refs.form.validate()) return null;
      this.loading = true;
      const data = {
        email: this.model.email,
        system: "pos",
      };
      this.API.auth
        .resetPassword(data)
        .then(() => {
          this.recoverySended = true;
        })
        .finally(() => (this.loading = false));
    },
    confirmLogin() {
      //Se guarda el token
      this[SAVE_TOKEN](this.userData.access_token);
      this[SET_LIST_POINT_OF_SALES](this.userData.listPointOfSale);
      //Se obtiene los datos del usuario y se guardan
      this.API.auth.me().then((userData) => {
        this[SAVE_USER](userData);
      });

      if (this.userData.pointOfSaleSelected) {
        this.$router.push(`/designer/${this.userData.pointOfSaleSelected}`);
      } else {
        this.$router.push("/designer/create");
      }
    },
    t(key, options = {}) {
      return this.$t(`public.landing.login.${key}`, options);
    },
  },
};
</script>
